import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './style.css';

class DialogBody extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children, isOverFlowVisible = false } = this.props;
    return (
      <div
        ref="diagbody"
        className={cx('v3-dialog-body', {
          'overflow-visible': isOverFlowVisible,
        })}
      >
        {children}
      </div>
    );
  }
}

DialogBody.propTypes = {
  children: PropTypes.node,
  isOverFlowVisible: PropTypes.bool,
};

export default DialogBody;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/Dialog/components/DialogBody/index.js
 **/